import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';
import requireUser from '../../lib/requireUser';
import log from '../../lib/log';
import { setUserStatus } from '../../lib/userStatus';
import isValidUser from '../../lib/isValidUser';
import { ServiceUserUtils } from '../../lib/serviceUserUtils';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

/**
 * The reject event indicates that a recipient has rejected a call.
 * @param event
 */
async function handleAgentSessionRejected(
  event: Telecom.AgentSessionRejectedEvent,
) {
  trackRTCSEventLatency(event.timestamp, RTCSEventType.SESSION_REJECTED);

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:session_rejected:' + user?.name, event);

  user.stats = userStatsFromAgentStats(event.stats);

  // update our status. status can be changed again
  setUserStatus({
    userId: user.id,
    status: event.available ? UserSetAvailabilityStatus.Available : undefined,
  });
  ServiceUserUtils.setEventActivityStatus(user, '');

  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.REJECTED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
    },
  );
}

export default handleAgentSessionRejected;
